import {RemoteGetWellBornEligibility} from 'data/usecases/private/well-born/remote-get-eligibility';
import {GetWellBornEligibility} from 'domain/usecases/private/well-born/get-well-born-eligibility';
import {makeAxiosHttpClient} from 'main/factories/http/axios-http-client-factory';
import {WellBornEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetWellBornEligibility = (): GetWellBornEligibility =>
	new RemoteGetWellBornEligibility(WellBornEndpoints.eligibility, makeAxiosHttpClient());
